module.exports = __webpack_public_path__ + "media/images/redesign-images/home/design-flatlays/design-6-19acc76bfb55b23a0eaef6c309888ac4.png";